import React from 'react' //{ useState, useEffect }

export default function HomePage(props) {
  return (
    <div>
      <h1>Home Page</h1>
    </div>
  )
}
